import _taggedTemplateLiteral from "@babel/runtime-corejs3/helpers/taggedTemplateLiteral";
var _templateObject;
import { gql } from "@apollo/client";
export default gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    fragment ListingStateChipFragment on MasterlistingNode {\n        listingState\n    }\n"])));